import { checkIsOneyPaymentByType } from '@/lib/payment/helpers';
import type { PaymentType } from '@/lib/payment/types';
import { PAYMENT_TYPES } from '@/lib/payment/types';
import { getRegionFromLocale } from '@/lib/regions';
import type { PaymentMethodConfiguration } from '@/states/paymentGatewaysState';

export const checkCountryBillingSameShippingAddressAffirm = (
  billingCountry?: string,
  locale?: string,
  method?: string,
) => {
  if (
    !method ||
    !locale ||
    !billingCountry ||
    method !== PAYMENT_TYPES.AFFIRM
  ) {
    return true;
  }

  const { country } = getRegionFromLocale(locale);

  if (country.code !== billingCountry) return false;

  return true;
};

export const isPaymentMethodDisabled = (
  availablePaymentMethods: PaymentMethodConfiguration[],
  isMulticard?: boolean,
  paymentMethod?: PaymentType | null,
) => {
  const paymentMethodConfiguration = availablePaymentMethods.find(
    (item) => item.type === paymentMethod,
  );
  if (!paymentMethodConfiguration) {
    return true;
  }
  return (
    (isMulticard &&
      paymentMethodConfiguration?.dropInConfiguration?.splitPayment ===
        false) ||
    (!isMulticard &&
      paymentMethodConfiguration?.dropInConfiguration?.available === false)
  );
};

export const isPaymentMethodSelectable = (
  availablePaymentMethods: PaymentMethodConfiguration[],
  isMulticard?: boolean,
  paymentMethod?: PaymentType,
  maxPayments?: number,
  limitMax?: number,
  maxAmount?: number,
) => {
  const paymentMethodConfiguration = availablePaymentMethods.find(
    (item) => item.type === paymentMethod,
  );
  if (
    paymentMethodConfiguration &&
    ((isMulticard &&
      paymentMethodConfiguration.dropInConfiguration?.splitPayment !== false) ||
      (!isMulticard &&
        paymentMethodConfiguration.dropInConfiguration?.available !== false))
  ) {
    return true;
  }

  if (
    (paymentMethod === PAYMENT_TYPES.AFFIRM ||
      paymentMethod === PAYMENT_TYPES.ZIP ||
      paymentMethod === PAYMENT_TYPES.FACILYPAY_3X ||
      paymentMethod === PAYMENT_TYPES.FACILYPAY_4X ||
      paymentMethod === PAYMENT_TYPES.CEMBRA ||
      paymentMethod === PAYMENT_TYPES.CEMBRA_INVOICE) &&
    isMulticard &&
    maxPayments === 1 &&
    maxAmount &&
    limitMax &&
    Number(maxAmount) > limitMax
  ) {
    return true;
  }
  return false;
};

export const filterPaymentMethods = (
  paymentMethods: PaymentMethodConfiguration[],
  locale?: string,
  billingCountryCode?: string,
) => {
  return paymentMethods.reduce((arr, current) => {
    const isAffirmPaymentAvailable =
      checkCountryBillingSameShippingAddressAffirm(
        billingCountryCode,
        locale,
        current.type,
      );
    if (!isAffirmPaymentAvailable) return arr;

    const isOnePayment = checkIsOneyPaymentByType(current.type);
    const hasOnePayment = arr.find((item) =>
      checkIsOneyPaymentByType(item.type),
    );
    if (!isOnePayment || !hasOnePayment) {
      arr.push(current);
    }
    return arr;
  }, [] as PaymentMethodConfiguration[]);
};
